<template>
  <div v-if="!logado"></div>
  <router-view v-else></router-view>
</template>

<script>
export default {
  name: 'Clientes',
  components: {},
  data () {
    return {
      logado: false
    }
  },
  methods: {},
  watch: {
    '$route' (to, from) {
      this.$parent.focusIptSearch()
    }
  },
  created: function () {
    this.logado = this.$root.auth
    this.$parent.focusIptSearch()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Clientes.vue